import { CircularProgress } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import React, { useEffect, useMemo, useState } from 'react';
import { AiOutlineDelete } from 'react-icons/ai';
import { BsArrowLeft } from 'react-icons/bs';
import { HiSearch } from 'react-icons/hi';
import { MdOutlineNavigateNext } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Check from 'src/assets/images/CheckCircle.svg';
import Icon from 'src/assets/images/Icon.svg';
import noResults from 'src/assets/images/noResults.svg';
import Plus from 'src/assets/images/Plus.svg';
import { Modal } from 'src/components';
import Button from 'src/components/button';
import { getDiscountStorageValue } from 'src/components/discount-storage';
import ItemsModal from 'src/components/itemsModal';
import Order from 'src/components/order';
import { CurrencyAmount } from 'src/containers/currency';
import {
  addCurrentOrder,
  addCurrentOrderInfo,
  addCurrentUser
} from 'src/redux/action/currentOrder.action';
import { fetchOrderItems } from 'src/redux/action/orderItems.action';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';

const Table: React.FC = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const { users } = useSelector(
    ({ currentOrderData }: RootState) => currentOrderData
  );
  const { orderInfo } = useSelector(({ currentOrderData }: RootState) => currentOrderData);
  const [orderLoading, setOrderLoading] = useState(true);
  const [newTable, setNewTable] = useState(
    location?.state?.newTable ? location?.state?.newTable : false
  );
  const [tableHasItem, setTableHasItem] = useState(
    location?.state?.tableHasItem ? location?.state?.tableHasItem : false
  );
  const [previousData, setPreviousData] = useState<any>([]);
  const [hasFetched, setHasFetched] = useState(
    location?.state?.hasFetched ? location?.state?.hasFetched : false
  );

  const fetchTableDataBackOffice = async () => {
    const userInfo = JSON.parse(
      window.localStorage.getItem('userInfo') || ''
    );
    setOrderLoading(true);
    try {
      const data = await Service.get(
        `/floors/tables/one/${location.state.table.id}/backOffice`
      );
      const dataOrders = data?.data?.tableOpenCheck?.orderInfo;

      const user = null;
      const a = {
        businessId: userInfo?.businessInfo?.id,
        type: 'dine_in',
        tableId: location.state?.table?.id,
        tableName: data?.data?.tableOpenCheck?.name,
        userId: user,
        origin: 'pos_device',
        promo: null,
        deliveryCharge: 0,
        dataOrders: dataOrders,
        items:
          dataOrders.items.length > 0
            ? dataOrders.items.map((item: any) => {
                return {
                  id: item.id,
                  itemId: item.itemId,
                  name: item.itemName,
                  variantId: item.variantId,
                  variantName: item.variantName,
                  hasVariants: item.hasVariants,
                  identifierId: item.id,
                  quantity: item.quantity,
                  decreaseLimit: item.decreaseLimit,
                  spiceLevel: item.spiceLevel || null,
                  selectedModifiers: item.allModifiers.map(
                    (modifier: any) => {
                      const optionsWithSelected = modifier.options.map(
                        (option: any) => {
                          const optionInModifiers = item.modifiers
                            .find((mod: any) => mod.id === modifier.id)
                            ?.options.find(
                              (op: any) => op.id === option.id
                            );
                          return {
                            id: option.id,
                            price: option.price,
                            name: option.name,
                            hasSelected: !!optionInModifiers,
                          };
                        }
                      );
                      return {
                        id: modifier.id,
                        name: modifier.name,
                        options: optionsWithSelected,
                      };
                    }
                  ),
                  price: item?.originalPrice,
                  priceAfterItemDiscount: item?.priceAfterItemDiscount,
                  note: item?.note || '',
                  discountAmount: item?.originalPrice - item?.priceAfterItemDiscount,
                  itemLevelDiscount: item.itemLevelDiscount
                };
              })
            : [],
      };
      if (dataOrders.items.length > 0) {
        dispatch(addCurrentOrder({ ...a }));
        dispatch(addCurrentOrderInfo(dataOrders));
        setPreviousData(a.items);
        setTableHasItem(true);
        setHasFetched(true);
        setNewTable(false);
      } else {
        setNewTable(true);
        setTableHasItem(false);
      }
      setOrderLoading(false);
    } catch (err: any) {
      toastAlert('error', err.message);
      setOrderLoading(false);
    }
  };

  useEffect(() => {
    if (!location.state) {
      navigate('/dine-in');
    }
    if (location.state?.table?.customer) {
      const customer = location.state?.table?.customer;
      const user = customer?.id
        ? users.find((userInfo) => userInfo.id === customer.id)
        : null;
      if (user) {
        dispatch(
          addCurrentUser({
            id: user.id,
            name: user.name,
            email: user?.email || null,
            phone: parseFloat(user?.phone),
            image: user?.image || null,
          })
        );
      }
    }
    if (location.state?.hasFetched) {
      setOrderLoading(false);
      setHasFetched(location.state.hasFetched);
    }

    if (location.state?.tableHasItem) {
      setTableHasItem(location.state?.tableHasItem);
    }

    if (
      location.state?.type === 'takeaway' ||
      location.state?.type === 'delivery'
    ) {
      setOrderLoading(false);
    }

    if (location.state?.isEditing) {
      if (location.state?.hasFetched) {
        return;
      }
      const fetchTableData = async () => {
        const userInfo = JSON.parse(
          window.localStorage.getItem('userInfo') || ''
        );

        setOrderLoading(true);
        try {
          const data = await Service.get(`/orders/${location.state?.orderId}`);
          const dataOrders = data?.data?.data?.order;

          const user = dataOrders?.customer?.id
            ? users.find((userInfo) => userInfo.id === dataOrders.customer.id)
            : null;

          const a = {
            businessId: userInfo?.businessInfo?.id,
            type: location.state.type,
            tableId: location.state?.table?.id || null,
            tableName: location.state?.table?.name || null,
            userId: dataOrders?.customer?.id || null,
            origin: dataOrders.origin,
            customer: dataOrders?.customer,
            promo: dataOrders?.promo || null,
            deliveryCharge:
              location.state.type === 'delivery'
                ? dataOrders.deliveryCharge
                : 0,
            items:
              dataOrders.ordersItems.length > 0
                ? dataOrders.ordersItems.map((item: any) => {
                    return {
                      id: item.id,
                      itemId: item.itemId,
                      name: item.itemName,
                      variantId: item.variantId,
                      hasVariants: item.hasVariants,
                      variantName: item.variantName,
                      identifierId: item.id,
                      quantity: item.quantity,
                      spiceLevel: item.spiceLevel || null,
                      selectedModifiers: item.allModifiers.map(
                        (modifier: any) => {
                          const optionsWithSelected = modifier.options.map(
                            (option: any) => {
                              const optionInModifiers = item.modifiers
                                .find((mod: any) => mod.id === modifier.id)
                                ?.options.find(
                                  (op: any) => op.id === option.id
                                );
                              return {
                                id: option.id,
                                price: option.price,
                                name: option.name,
                                hasSelected: !!optionInModifiers,
                              };
                            }
                          );
                          return {
                            id: modifier.id,
                            name: modifier.name,
                            options: optionsWithSelected,
                          };
                        }
                      ),
                      price: item.discountedPrice,
                      note: item?.note || '',
                    };
                  })
                : [],
          };
          if (dataOrders.ordersItems.length > 0) {
            dispatch(addCurrentOrder({ ...a }));
            setOrderLoading(false);
            setHasFetched(true);
          }
        } catch (err: any) {
          setOrderLoading(false);
          toastAlert('error', err.message);
        }
      };
      fetchTableData();
    }

    if (location.state?.previousData) {
      setPreviousData(location.state?.previousData);
    }

    if (location.state?.fetchTable) {
      if (location.state?.hasFetched) {
        return;
      }
      fetchTableDataBackOffice();
    }
  }, [location.state, navigate]);

  const [currentItem, setCurrentItem] = useState('Items');
  const [showAddCustomModal, setShowAddCustomModal] = useState(false);
  const [currentCustomIds, setCurrentCustomIds] = useState<string[]>([]);
  const [filteredSearchItemModal, setFilteredSearchItemModal] = useState('');
  const [filteredSearchCustom, setFilteredSearchCustom] = useState('');
  const [filteredSearchItem, setFilteredSearchItem] = useState('');
  const [currentItemCategory, setCurrentItemCategory] = useState(
    location?.state?.currentItemCategory ?? 'all'
  );
  const [locCurrentItem, setLocCurrentItem] = useState(
    location.state?.currentItemCategory
  );
  const [selectCustom, setSelectCustom] = useState(false);
  const [selectedCustom, setSelectedCustom] = useState<string[]>([]);
  const [customItemLoading, setCustomItemLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [discountInfo, setDiscountInfo] = useState<any>(
    getDiscountStorageValue(orderInfo)
  );

  useEffect(() => {
    const discountStorage = getDiscountStorageValue(orderInfo);
    if (discountStorage) {
      setDiscountInfo({
        ...discountStorage,
      });
    }
  }, []);

  const dispatch = useDispatch();

  const { orderItemsData } = useSelector(
    ({ orderItemsData }: RootState) => orderItemsData
  );
  const {
    customItems,
    categoriesWithItems: categoriesWithItemsData,
    items,
  } = orderItemsData;
  const categoriesWithItems = categoriesWithItemsData?.sort((a, b) => {
    const nameA = a.name.replace(/[^a-zA-Z]/g, ''); // Remove special characters
    const nameB = b.name.replace(/[^a-zA-Z]/g, '');
    return nameA.localeCompare(nameB);
  });

  const filteredItemsModal = useMemo(() => {
    if (filteredSearchItemModal) {
      const trimmedSearch = filteredSearchItemModal.trim().toLowerCase();
      return items.filter((item) =>
        item.name.toLowerCase().includes(trimmedSearch)
      );
    } else {
      return items;
    }
  }, [filteredSearchItemModal]);

  const filteredCustom = useMemo(() => {
    const a = customItems || [];
    if (filteredSearchCustom) {
      const trimmedSearch = filteredSearchCustom.trim().toLowerCase();
      return a.filter((item) =>
        item.name.toLowerCase().includes(trimmedSearch)
      );
    } else {
      return a;
    }
  }, [filteredSearchCustom, customItems]);

  const filteredItems = useMemo(() => {
    const array =
      currentItemCategory === 'all'
        ? items || []
        : categoriesWithItems.find((i) => i.id === currentItemCategory)
            ?.items || [];

    let returnArray = [];
    if (filteredSearchItem) {
      const trimmedSearch = filteredSearchItem.trim().toLowerCase();
      returnArray = array?.filter((item) =>
        item.name.toLowerCase().includes(trimmedSearch)
      );
    } else {
      returnArray = array;
    }
    return returnArray;
  }, [filteredSearchItem, currentItemCategory]);

  React.useEffect(() => {
    dispatch(fetchOrderItems() as any);
  }, []);

  const handleModal = () => {
    setShowAddCustomModal(false);
    setCurrentCustomIds([]);
  };

  const handleSelectCustom = (id: string) => {
    if (selectedCustom.includes(id)) {
      return setSelectedCustom((item) => item.filter((i) => i !== id));
    }
    return setSelectedCustom((item) => [...item, id]);
  };

  // const handleSelectItem = (id: string) => {
  //   if (selectedItem.includes(id)) {
  //     return setSelectedItem((item) => item.filter((i) => i !== id));
  //   }
  //   return setSelectedItem((item) => [...item, id]);
  // };

  useEffect(() => {
    if (selectedCustom.length > 0) {
      setSelectCustom(true);
    } else {
      setSelectCustom(false);
    }
  }, [selectedCustom]);

  // useEffect(() => {
  //   if (selectedItem.length > 0) {
  //     setSelectItem(true);
  //   } else {
  //     setSelectItem(false);
  //   }
  // }, [selectedItem]);

  useEffect(() => {
    // setSelectItem(false);
    // setSelectedItem([]);
    setSelectCustom(false);
    setSelectedCustom([]);
    if (locCurrentItem) {
      setCurrentItemCategory(locCurrentItem);
      setLocCurrentItem(null);
    } else setCurrentItemCategory('all');
    setFilteredSearchCustom('');
    setFilteredSearchItem('');
  }, [currentItem]);

  // tracking individual looped item modal and for closing opening, which doesn't affect each other
  const [showItemsModal, setShowItemsModal] = useState<boolean[]>(
    filteredItems.map(() => false)
  );

  const [showCustomModal, setShowCustomModal] = useState<boolean[]>(
    filteredCustom.map(() => false)
  );

  // showing and hiding modal for individual looped item
  const handleModalItems = (index: number) => {
    const updatedModalStates = [...showItemsModal];
    updatedModalStates[index] = !updatedModalStates[index];
    setShowItemsModal(updatedModalStates);
  };

  // showing and hiding modal for individual looped item
  const handleModalCustom = (index: number) => {
    const updatedModalStates = [...showCustomModal];
    updatedModalStates[index] = !updatedModalStates[index];
    setShowCustomModal(updatedModalStates);
  };

  const handleClickVariants = (item: any, index: number) => {
    if (item.hasVariants) {
      navigate('/table/variants', {
        state: {
          item: item,
          type: location?.state?.type,
          isEditing: location?.state?.isEditing || false,
          orderId: location?.state?.orderId || null,
          tableId: location?.state?.table?.id || null,
          previousData: previousData,
          tableHasItem: tableHasItem,
          hasFetched: hasFetched,
          table: location?.state?.table || null,
          newTable: location?.state?.newTable
            ? location?.state.newTable
            : newTable,
          discountSend: discountInfo,
          currentItemCategory,
        },
      });
    } else {
      handleModalItems(index);
    }
  };

  const handleClickVariantsCustom = (item: any, index: number) => {
    if (item.hasVariants) {
      navigate('/table/variants', {
        state: {
          item: item,
          type: location?.state?.type,
          isEditing: location?.state?.isEditing || false,
          orderId: location?.state?.orderId || null,
          tableId: location?.state?.table?.id || null,
          previousData: previousData,
          hasFetched: hasFetched,
          tableHasItem: tableHasItem,
          table: location?.state?.table || null,
          newTable: location?.state?.newTable
            ? location?.state?.newTable
            : newTable,
        },
      });
    } else {
      handleModalCustom(index);
    }
  };

  const addCustomItem = async (id: string[]) => {
    if (id.length === 0) return;
    setCustomItemLoading(true);
    const data = { ids: id };
    try {
      await Service.post('/employees/addCustom', data);
      dispatch(fetchOrderItems() as any);
      toastAlert('success', `Added item successfully`);
      handleModal();
      setCustomItemLoading(false);
    } catch (err: any) {
      toastAlert('error', err.message);
      setCustomItemLoading(false);
    }
  };

  const handleCustomDelete = async () => {
    const data = { ids: selectedCustom };
    setDeleteLoading(true);
    try {
      await Service.post('/employees/removeCustom', data);
      dispatch(fetchOrderItems() as any);
      toastAlert('success', `Item removed successfully`);
      setSelectedCustom([]);
      setSelectCustom(false);
      setDeleteLoading(false);
    } catch (err: any) {
      toastAlert('error', err.message);
      setDeleteLoading(false);
    }
  };

  return (
    <>
      <div className="flex flex-row justify-between h-[41px] text-black absolute -top-[68px]">
        <div
          className="flex flex-row gap-3 items-center cursor-pointer"
          onClick={() => {
            navigate('/dine-in');
          }}
        >
          <BsArrowLeft fontSize={20} />
          <div className="font-Outfit font-semibold text-[20px] leading-[32px]">
            {location.state?.type === 'dine_in' && (
              <>Table {location.state?.table.name}</>
            )}
            {location.state?.type === 'takeaway' && <>Takeaway</>}
            {location.state?.type === 'delivery' && <>Delivery</>}
          </div>
        </div>
        {/* <div className="ml-auto w-[151px] bg-primary text-pure-white flex justify-center items-center rounded-lg gap-1 cursor-pointer">
                <AiOutlinePlus />
                <div className="font-Outfit font-semibold text-[14px] leading-[21px]">
                  Create item
                </div>
              </div> */}
      </div>
      <div className="w-full h-[calc(100vh-75px)] text-black flex flex-row justify-between gap-4">
        <div className="w-full h-full flex flex-col gap-[18px]">
          <div className="flex flex-row justify-between items-center  h-[41px]">
            <div className="flex flex-row gap-6 h-[41px] items-center  cursor-pointer">
              <div
                onClick={() => {
                  setCurrentItem('Items');
                }}
                className={`h-full flex items-center font-Sarabun font-normal leading-5 hover:text-primary text-[16px] ${
                  currentItem === 'Items'
                    ? 'text-primary border-b-[2px] border-primary'
                    : 'text-[#2B2B2B]'
                }`}
              >
                Items
              </div>
              {/* <div
                onClick={() => {
                  setCurrentItem('Set Menu');
                }}
                className={`h-full flex items-center font-Sarabun font-normal leading-5 hover:text-primary text-[16px] ${
                  currentItem === 'Set Menu'
                    ? 'text-primary border-b-[2px] border-primary'
                    : 'text-[#2B2B2B]'
                }`}
              >
                Set Menu
              </div> */}
              {/* <div
                onClick={() => {
                  setCurrentItem('Combo');
                }}
                className={`h-full flex items-center font-Sarabun font-normal leading-5 hover:text-primary text-[16px] ${
                  currentItem === 'Combo'
                    ? 'text-primary border-b-[2px] border-primary'
                    : 'text-[#2B2B2B]'
                }`}
              >
                Combo
              </div> */}
              {/* <div
                onClick={() => {
                  setCurrentItem('Discount');
                }}
                className={`h-full flex items-center font-Sarabun font-normal leading-5 hover:text-primary text-[16px] ${
                  currentItem === 'Discount'
                    ? 'text-primary border-b-[2px] border-primary'
                    : 'text-[#2B2B2B]'
                }`}
              >
                Discount
              </div> */}
              {/* <div
                className={`h-full flex items-center font-Sarabun font-normal leading-5 hover:text-primary text-[16px] ${
                  currentItem === 'Custom'
                    ? 'text-primary border-b-[2px] border-primary'
                    : 'text-[#2B2B2B]'
                }`}
                onClick={() => {
                  setCurrentItem('Custom');
                }}
              >
                Custom
              </div> */}
            </div>

            {currentItem === 'Custom' && (
              <>
                <div className="ml-auto relative flex items-center w-[277px] h-[41px]">
                  <input
                    type="text"
                    placeholder="Search custom items"
                    className="pr-9 flex-1 w-full px-4 py-2 border border-[#CACFE3] rounded-full focus:outline-none   "
                    onChange={(e) => {
                      setFilteredSearchCustom(e.target.value);
                    }}
                  />
                  <div className="absolute right-3">
                    <HiSearch color="#7F8397" style={{ fontSize: '20px' }} />
                  </div>
                </div>
              </>
            )}
            {currentItem === 'Items' && (
              <>
                <div className="ml-auto relative flex items-center w-[277px] h-[41px]">
                  <input
                    type="text"
                    placeholder="Search items"
                    className="pr-9 flex-1 w-full px-4 py-2 border border-[#CACFE3] rounded-full focus:outline-none   "
                    onChange={(e) => {
                      setFilteredSearchItem(e.target.value);
                    }}
                  />
                  <div className="absolute right-3">
                    <HiSearch color="#7F8397" style={{ fontSize: '20px' }} />
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="h-[calc(100vh-100px)] ">
            {selectCustom && (
              <>
                <div className="flex flex-row justify-between items-center h-[31px]">
                  <div>
                    <div className="flex flex-row  h-full items-center">
                      <Checkbox
                        checked={filteredCustom
                          .map((item) => item.id)
                          .every((id) => selectedCustom.includes(id))}
                        sx={{
                          color: '#949CC0',
                          '&.Mui-checked': {
                            color: '#4062FF',
                          },
                        }}
                        onChange={() => {
                          if (
                            filteredCustom
                              .map((item) => item.id)
                              .every((id) => selectedCustom.includes(id))
                          ) {
                            setSelectedCustom([]);
                          } else {
                            setSelectedCustom((item) => {
                              const uniqueIds = new Set([
                                ...item,
                                ...filteredCustom.map((items) => items.id),
                              ]);
                              return [...uniqueIds];
                            });
                          }
                        }}
                      />
                      <div className="pr-3 border-r border-[#949CC0] font-Sarabun font-bold text-[16px] leading-6">
                        All
                      </div>
                      <div className="pl-3 text-primary font-Sarabun font-bold text-[16px] leading-6">
                        {selectedCustom.length} Selected
                      </div>
                    </div>
                  </div>
                  <div
                    className="w-[101px] h-[31px] cursor-pointer border flex gap-2 justify-center items-center border-warning text-warning rounded-full"
                    onClick={() => handleCustomDelete()}
                  >
                    <AiOutlineDelete />
                    <div className="font-Outfit font-normal text-[14px] leading-[21px]">
                      Delete
                    </div>
                  </div>
                </div>
              </>
            )}
            <>
              {/* {selectItem && (
              <>
                <div className="flex flex-row justify-between items-center h-[31px]">
                  <div>
                    <div className="flex flex-row  h-full items-center">
                      <Checkbox
                        checked={filteredItems
                          .map((item) => item.id)
                          .every((id) => selectedItem.includes(id))}
                        sx={{
                          color: '#949CC0',
                          '&.Mui-checked': {
                            color: '#4062FF',
                          },
                        }}
                        onChange={() => {
                          if (
                            filteredItems
                              .map((item) => item.id)
                              .every((id) => selectedItem.includes(id))
                          ) {
                            setSelectedItem([]);
                          } else {
                            setSelectedItem((item) => {
                              const uniqueIds = new Set([
                                ...item,
                                ...filteredItems.map((items) => items.id),
                              ]);
                              return [...uniqueIds];
                            });
                          }
                        }}
                      />
                      <div className="pr-3 border-r border-[#949CC0] font-Sarabun font-bold text-[16px] leading-6">
                        All
                      </div>
                      <div className="pl-3 text-primary font-Sarabun font-bold text-[16px] leading-6">
                        {selectedItem.length} Selected
                      </div>
                    </div>
                  </div>
                  <div className="w-[101px] h-[31px] cursor-pointer border flex gap-2 justify-center items-center border-warning text-warning rounded-full">
                    <AiOutlineDelete />
                    <div className="font-Outfit font-normal text-[14px] leading-[21px]">
                      Delete
                    </div>
                  </div>
                </div>
              </>
            )} */}
            </>

            {currentItem === 'Custom' && (
              <div className="w-full flex flex-row flex-wrap justify-start salesTableLayout">
                {filteredCustom?.length > 0 ? (
                  <>
                    {filteredCustom.map((i, ind) => (
                      <div
                        className="relative w-[120px] h-[185px] flex flex-col cursor-pointer "
                        key={i.id}
                      >
                        {i.image ? (
                          <img
                            src={i.image}
                            alt={i.name}
                            className=" w-full h-[120px] rounded-xl object-cover"
                            onClick={(e) => {
                              handleSelectCustom(i.id);
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              backgroundColor: i.color || '#ECAA00',
                            }}
                            onClick={(e) => {
                              handleSelectCustom(i.id);
                            }}
                            className=" h-[120px] rounded-xl"
                          />
                        )}

                        <div
                          className="h-[38px] flex items-center w-full gap-2 "
                          onClick={() => handleClickVariantsCustom(i, ind)}
                        >
                          {!i.hasVariants && i?.variants[0]?.isVeg && (
                            <img src={Icon} alt="icon" />
                          )}
                          <div
                            className=" font-Outfit font-semibold text-[14px] leading-[18px] "
                            style={{
                              width: '100%',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {i?.name}
                          </div>
                        </div>

                        {i.hasVariants ? (
                          <div
                            className="h-[21px] flex justify-between items-center mt-auto"
                            onClick={() => handleClickVariantsCustom(i, ind)}
                          >
                            <div className="font-Outfit font-semibold text-[14px] leading-[21px] text-[#949CC0]">
                              {i.hasVariants
                                ? `${i?.variants?.length} Variants`
                                : <CurrencyAmount amount={i?.variants[0]?.price}/>}
                            </div>

                            {i.hasVariants && (
                              <MdOutlineNavigateNext
                                fontSize={20}
                                color="#949CC0"
                              />
                            )}
                          </div>
                        ) : (
                          <>
                            <div
                              className="h-[21px] flex gap-2 items-center mt-auto"
                              onClick={() => handleClickVariantsCustom(i, ind)}
                            >
                              {i.discount ? (
                                <>
                                  <div
                                    className="font-Outfit font-semibold text-[14px] leading-[21px] text-[#949CC0]"
                                    style={{ textDecoration: 'line-through' }}
                                  >
                                    {i.hasVariants
                                      ? `${i?.variants?.length} Variants`
                                      : <CurrencyAmount amount={i?.variants[0]?.price}/>}
                                  </div>
                                  <div className="font-Outfit font-semibold text-[14px] leading-[21px] text-[#949CC0]">
                                    {i.hasVariants
                                      ? `${i?.variants?.length} Variants`
                                      : <CurrencyAmount amount={i?.variants[0]?.discountedPrice}/>}
                                  </div>
                                </>
                              ) : (
                                <div className="font-Outfit font-semibold text-[14px] leading-[21px] text-[#949CC0]">
                                  {i.hasVariants
                                    ? `${i?.variants?.length} Variants`
                                    : <CurrencyAmount amount={i?.variants[0]?.price}/>}
                                </div>
                              )}
                            </div>
                          </>
                        )}
                        {selectedCustom.includes(i.id) && (
                          <div
                            className="absolute w-[120px] h-[120px] rounded-xl flex justify-center items-center bg-primary bg-opacity-50"
                            onClick={() => {
                              handleSelectCustom(i.id);
                            }}
                          >
                            <img src={Check} alt="check" />
                          </div>
                        )}
                        {showCustomModal[ind] && (
                          <ItemsModal
                            handleClose={() => handleModalCustom(ind)}
                            items={i}
                            item={i.variants[0]}
                            showModal={showCustomModal[ind]}
                            type={location.state?.type}
                            tableId={location.state?.table?.id || null}
                            tableName={location.state?.table.name}
                            fetchTableDataBackOffice={fetchTableDataBackOffice}
                          />
                        )}
                      </div>
                    ))}

                    {filteredSearchCustom.trim().length <= 0 && (
                      <div
                        className="w-[120px] h-[185px] flex justify-center items-center cursor-pointer border-[2px] rounded-xl border-dashed border-[#4062FF]"
                        onClick={() => {
                          setShowAddCustomModal(true);
                        }}
                      >
                        <img src={Plus} alt="plus" />
                      </div>
                    )}
                  </>
                ) : (
                  <div
                    className="w-[120px] h-[185px] flex justify-center items-center cursor-pointer border-[2px] rounded-xl border-dashed border-[#4062FF]"
                    onClick={() => {
                      setShowAddCustomModal(true);
                    }}
                  >
                    <img src={Plus} alt="plus" />
                  </div>
                )}
              </div>
            )}

            {currentItem === 'Items' && (
              <div className="flex flex-row w-full justify-center">
                <div className="max-h-[calc(100vh-140px)] overflow-y-auto min-w-[170px] max-w-[170px]  flex flex-col gap-[16px] border-r border-[#E9ECFF] mr-[31px]">
                  <div
                    onClick={() => setCurrentItemCategory('all')}
                    className={`cursor-pointer w-[169px] font-Outfit font-normal  text-[16px] hover:text-primary leading-6 ${
                      currentItemCategory === 'all'
                        ? 'text-primary border-r-[2px]'
                        : 'text-[#949CC0]'
                    }`}
                  >
                    All
                  </div>
                  {categoriesWithItems.map((i) => (
                    <div
                      key={i.id}
                      onClick={() => setCurrentItemCategory(i.id)}
                      className={`cursor-pointer min-w-[169px] max-w-[169px] font-Outfit font-normal text-[16px] hover:text-primary leading-6 ${
                        currentItemCategory === i.id
                          ? 'text-primary border-r-[2px]'
                          : 'text-[#949CC0]'
                      }`}
                    >
                      {i.name}
                    </div>
                  ))}
                </div>
                <div className="w-full flex flex-row flex-wrap  justify-start salesTableLayout">
                  {filteredItems?.length > 0 ? (
                    <>
                      {filteredItems?.map((item, indd) => {
                        return (
                          <div
                            className="relative w-[120px]  h-[185px] flex flex-col cursor-pointer "
                            key={item.id}
                          >
                            {item.image ? (
                              <img
                                src={item.image}
                                alt={item.name}
                                className=" w-full h-[120px] rounded-xl object-cover"
                                // onClick={(e) => {
                                //   handleSelectItem(item.id);
                                // }}
                                onClick={() => handleClickVariants(item, indd)}
                              />
                            ) : (
                              <div
                                style={{
                                  backgroundColor:
                                    item.color === '#FFFFFF'
                                      ? '#ECAA00'
                                      : item.color || '#ECAA00',
                                }}
                                className=" h-[120px] rounded-xl"
                                // onClick={(e) => {
                                //   handleSelectItem(item.id);
                                // }}
                                onClick={() => handleClickVariants(item, indd)}
                              />
                            )}

                            <div
                              className="h-[38px] flex items-center w-full gap-2 "
                              onClick={() => handleClickVariants(item, indd)}
                            > 
                              {!item.hasVariants &&
                                item?.variants?.[0]?.isVeg && (
                                  <img src={Icon} alt="icon" />
                                )}

                              <div
                                className=" font-Outfit font-semibold text-[14px] leading-[18px] "
                                style={{
                                  width: '100%',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                {item?.name}
                              </div>
                            </div>

                            {item.hasVariants ? (
                              <div
                                className="h-[21px] flex justify-between items-center mt-auto"
                                onClick={() => handleClickVariants(item, indd)}
                              >
                                <div className="font-Outfit font-semibold text-[14px] leading-[21px] text-[#949CC0]">
                                  {item.hasVariants
                                    ? `${item?.variants?.length} Variants`
                                    : <CurrencyAmount amount={item?.variants[0]?.price}/>}
                                </div>

                                {item.hasVariants && (
                                  <MdOutlineNavigateNext
                                    fontSize={20}
                                    color="#949CC0"
                                  />
                                )}
                              </div>
                            ) : (
                              <>
                                <div
                                  className="h-[21px] flex gap-2 items-center mt-auto"
                                  onClick={() =>
                                    handleClickVariants(item, indd)
                                  }
                                >
                                  {item.discount ? (
                                    <>
                                      <p className="font-Outfit font-semibold text-[14px] leading-[21px] text-[#949CC0]">
                                        {item.hasVariants
                                          ? `${item?.variants?.length} Variants`
                                          : <CurrencyAmount className='line-through text-light-gray font-normal' amount={item?.variants[0]?.price}/>}
                                      </p>
                                      <div className="font-Outfit font-semibold text-[14px] leading-[21px] text-[#949CC0]">
                                        {item.hasVariants
                                          ? `${item?.variants?.length} Variants`
                                          : <CurrencyAmount amount={item?.variants[0]?.discountedPrice}/>}
                                      </div>
                                    </>
                                  ) : (
                                    <div className="font-Outfit font-semibold text-[14px] leading-[21px] text-[#949CC0]">
                                      {item.hasVariants
                                        ? `${item?.variants?.length} Variants`
                                        : <CurrencyAmount amount={item?.variants[0]?.price}/>}
                                    </div>
                                  )}
                                </div>
                              </>
                            )}

                            {showItemsModal[indd] && (
                              <ItemsModal
                                handleClose={() => handleModalItems(indd)}
                                items={item}
                                item={item.variants[0]}
                                showModal={showItemsModal[indd]}
                                type={location.state.type}
                                tableId={location.state?.table?.id || null}
                                tableName={location.state?.table.name}
                                fetchTableDataBackOffice={fetchTableDataBackOffice}
                              />
                            )}
                            {/* {selectedItem.includes(item.id) && (
                              <div
                                className="absolute w-[120px] h-[120px] rounded-xl flex justify-center items-center bg-primary bg-opacity-50"
                                onClick={(e) => {
                                  handleSelectItem(item.id);
                                }}
                              >
                                <img src={Check} alt="check" />
                              </div>
                            )} */}
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <div>No items found.</div>
                  )}
                </div>
              </div>
            )}

            {currentItem === 'Set Menu' && (
              <div className="flex flex-col items-center justify-center w-full salesTableLayout">
                <div className="w-[351px] h-[285px] flex items-center justify-center  mt-8">
                  <img src={noResults} alt="noResults" />
                </div>
                <div className="font-Outfit font-semibold text-xl mt-3">
                  No results to show
                </div>
              </div>
            )}
            {currentItem === 'Discount' && (
              <div className="flex flex-col items-center justify-center w-full salesTableLayout">
                <div className="w-[351px] h-[285px] flex items-center justify-center  mt-8">
                  <img src={noResults} alt="noResults" />
                </div>
                <div className="font-Outfit font-semibold text-xl mt-3">
                  No results to show
                </div>
              </div>
            )}
            {currentItem === 'Combo' && (
              <div className="flex flex-col items-center justify-center w-full salesTableLayout">
                <div className="w-[351px] h-[285px] flex items-center justify-center  mt-8">
                  <img src={noResults} alt="noResults" />
                </div>
                <div className="font-Outfit font-semibold text-xl mt-3">
                  No results to show
                </div>
              </div>
            )}
          </div>

          {showAddCustomModal && (
            <Modal
              title="Select items"
              onClick={handleModal}
              className="w-[389px]"
            >
              <div className=" mt-4">
                <div className="flex flex-col items-center justify-end mt-6 ">
                  <div className="relative flex items-center w-[338px] h-[40px] mb-4">
                    <input
                      type="text"
                      placeholder="Search item"
                      className="pr-9 flex-1 w-full px-4 py-2 border border-[#CACFE3] rounded-full focus:outline-none "
                      onChange={(e) => {
                        setFilteredSearchItemModal(e.target.value);
                      }}
                    />
                    <div className="absolute right-3">
                      <HiSearch color="#7F8397" style={{ fontSize: '20px' }} />
                    </div>
                  </div>
                  <div className="w-full mb-6 h-fit max-h-[348px] overflow-y-scroll flex flex-col gap-3">
                    {filteredItemsModal.map((i) => (
                      <div
                        key={i.id}
                        className={`h-[48px] w-full flex justify-between items-center border  rounded-xl p-4 cursor-pointer ${
                          currentCustomIds.includes(i.id)
                            ? 'border-primary'
                            : 'border-[#CACFE3]'
                        }`}
                        onClick={() => {
                          setCurrentCustomIds((ids) =>
                            ids.includes(i.id)
                              ? ids.filter((id) => id !== i.id)
                              : [...ids, i.id]
                          );
                        }}
                      >
                        {i.name}
                      </div>
                    ))}
                  </div>
                  <Button
                    text="Add to custom"
                    variant="primary"
                    type="submit"
                    className="ml-auto"
                    disabled={customItemLoading}
                    onClick={() => addCustomItem(currentCustomIds)}
                  />
                </div>
              </div>
            </Modal>
          )}
        </div>

        {newTable || (tableHasItem && hasFetched) || location.state?.isEmpty ? (
          <Order
            isEditing={location.state?.isEditing || false}
            orderId={location.state?.orderId || null}
            orderData={location.state?.orderData || null}
            payment={false}
            newTable={newTable}
            tableHasItem={tableHasItem}
            tableId={location.state?.table?.id}
            previousData={previousData}
            isWebsite={location.state?.isWebsite || false}
            setDiscountInfo={setDiscountInfo}
            fetchTableDataBackOffice={fetchTableDataBackOffice}
          />
        ) : orderLoading ? (
          <div className="w-[332px] h-[calc(100vh-75px)] flex justify-center items-center  ">
            <CircularProgress color="primary" />
          </div>
        ) : (
          <Order
            isEditing={location.state?.isEditing || false}
            orderId={location.state?.orderId || null}
            payment={false}
            newTable={newTable}
            tableHasItem={tableHasItem}
            tableId={location.state?.table?.id}
            previousData={previousData}
            isWebsite={location.state?.isWebsite || false}
            fetchTableDataBackOffice={fetchTableDataBackOffice}
          />
        )}
      </div>
    </>
  );
};

export default Table;
